import { observer } from 'mobx-react';
import { T } from '../../../../../../../../../../Translations';

function CardDescription() {
  return (
    <>
      <p className="text-sm font-normal text-black">
        <T kind="You may still add this program to your collection right now and will not be charged for any additional licenses at this moment." />
      </p>
      <p className="text-sm font-normal text-black">
        <T kind="Participants will only gain access if you obtain the right license. Otherwise their access to this program will be restricted." />
      </p>
      <p className="text-sm font-normal text-black">
        <T kind="Once it’s part of your collection, you may also hide unlicensed programs from your collection and activate them at a later point." />
      </p>
      <p className="text-sm font-normal text-black">
        <T kind="Learn more by talking to your ExecOnline Rep or by clicking here." />
      </p>
    </>
  );
}

export default observer(CardDescription);
